import { NS as ViewerPlannerNS } from '../components/viewer/planner/Planner/ViewerPlanner';
import EngineModule              from '../EngineModule';

export default () =>  EngineModule.all.find(x => x.id === 'viewer-planner') || new EngineModule.LogicalEngineModule({
	type :             'logical',
	id :               'viewer-planner',
	dependencies :     [ 'oms-basket' ],
	allowedCustomers : null,
	insertionPath :    'K.visualization.V',
	generateComponentConfiguration() : ViewerPlannerNS.Configuration {
		return {
			groundMaterialTree :                  this.configuration.groundMaterialTree,
			doNotDisplayFurniturePriceIfItsZero : true,
			size :                                { width : 1, depth : 1, height : 0.1 },
			naturalSize :                         { width : 1, depth : 1, height : 0.1 },
			applyDefaultSize :                    false
		};
	},
	async initialize() {
	}
});
